export default __webpack_public_path__ + "static/media/calendario.c1726bea.svg";